import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Footer from "./components/Footer";
import Header from "./components/Header";

import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Admision from "./pages/Admision";
import Campus from "./pages/Campus";
import History from "./pages/History";
import Inscription from "./pages/Inscription";
import Career from "./pages/Career";
import Faq from "./pages/Faq";

import "./assets/css/styles.css";
import "./assets/css/colors.css";

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mision-y-vision" element={<AboutUs />} />
          <Route path="/sedes/:id" element={<Campus />} />
          <Route path="/historia" element={<History />} />
          <Route path="/carreras/:id" element={<Career />} />
          <Route path="/cursos" element={<Career />} />
          <Route path="/diplomados" element={<Career />} />
          <Route path="/licenciaturas" element={<Career />} />
          <Route path="/admision" element={<Admision />} />
          <Route path="/inscripcion" element={<Inscription />} />
          <Route path="/preguntas-frecuentes" element={<Faq />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
